<template>
  <v-autocomplete
    :items="items"
    item-text="descricao"
    item-value="id"
    v-bind="$attrs"
    v-bind:value="modelValue"
    v-on="inputListeners"
    :loading="loading"
  >
    <template #progress>
      <v-progress-linear
        style="position: absolute"
        height="2px"
        :color="cor_loading"
        indeterminate
      ></v-progress-linear>
    </template>

    <template #prepend-item v-if="!desativarSelecionarTodos && multiplaSelecao && items.length">
      <v-list-item
        v-if="modelValue.length === items.length"
        class="pl-14px py-2"
        @click="updateModel([])"
      >
        <v-icon class="ml-2" color="primary">mdi-checkbox-marked</v-icon>
        <span class="ml-2 font-weight-medium">Desmarcar Todas</span>
      </v-list-item>

      <v-list-item
        v-else
        class="pl-14px py-2"
        @click="updateModel(Helpers.arrayColumn(items, 'id'))"
      >
        <v-icon v-if="modelValue.length > 0" class="ml-2" color="primary">mdi-minus-box</v-icon>
        <v-icon v-else class="ml-2">mdi-checkbox-blank-outline</v-icon>
        <span class="ml-2 font-weight-medium">Selecionar Todas</span>
      </v-list-item>

      <v-divider />
    </template>

    <template #selection="{item}" v-if="multiplaSelecao">
      <template v-if="modelValue.indexOf(item.id) < qtdeVisivelSelecionados">
        <span>{{item.descricao}}</span><template v-if="apendarVirgula(item)">,&nbsp;</template>
      </template>

      <template v-if="modelValue.indexOf(item.id) === qtdeVisivelSelecionados">
        <span class="ml-1 text-grat-900">(+ {{modelValue.length - qtdeVisivelSelecionados}})</span>
      </template>
    </template>

    <template #prepend-inner>
      <slot name="prepend-inner" />
    </template>
  </v-autocomplete>
</template>

<script>
import {buscarSecoes} from "@/api/compraPorDepartamentos/Secao";
import {arrayColumn, logout} from "@/helpers";

export default {
  name: "SysSecaoAutocomplete",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: [Number, String, Array],
      required: true
    },
    qtdeVisivelSelecionados: {
      type: [Number],
      default: 1
    },
    desativarSelecionarTodos: {
      type: Boolean,
      default: false
    },
    cor_loading: {
      type: String,
      default: 'red'
    },
    idsGrupo: {
      type: Array,
      default: () => ([])
    },
    idsFilial: {
      type: Array,
      default: () => ([])
    },
    idsSegmento: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    items: [],
    loading: false,
    timer_buscar_items: null
  }),
  computed: {
    multiplaSelecao () {
      return ![null, undefined].includes(this.$attrs.multiple)
    },
    inputListeners: function () {
      const vm = this

      return Object.assign({},
        vm.$listeners, {
          input: function (values) {
            if ([null, undefined].includes(values)) {
              values = vm.$attrs.multiple ? [] : '';
            }

            vm.updateModel(values)
          }
        }
      )
    }
  },
  watch: {
    idsGrupo(novo, antigo) {
      this.verificaAtualizacaoFiltros(novo, antigo);
    },
    idsFilial(novo, antigo) {
      this.verificaAtualizacaoFiltros(novo, antigo);
    },
    idsSegmento(novo, antigo) {
      this.verificaAtualizacaoFiltros(novo, antigo);
    }
  },
  mounted() {
    this.getItems();
  },
  methods: {
    verificaAtualizacaoFiltros(novo, antigo) {
      if (novo.length !== antigo.length) {
        clearTimeout(this.timer_buscar_items);
        this.timer_buscar_items = setTimeout(this.getItems, 2000);
      }
    },
    updateModel(values) {
      const valuesValidos = values ? values : (this.multiplaSelecao ? [] : '')
      this.$emit('update:modelValue', valuesValidos)
    },
    getItems () {
      this.loading = true

      if (!this.multiplaSelecao) {
        this.updateModel('');
      }

      const parametros = {
        grupos: this.idsGrupo,
        filiais: this.idsFilial,
        segmentos: this.idsSegmento
      };

      buscarSecoes(parametros)
        .then(secoes => {
          this.items = secoes;
          this.loading = false;
          this.atualizarFiliaisSelecionadas();
        })
        .catch(logout)
    },
    atualizarFiliaisSelecionadas() {
      if (!this.multiplaSelecao) return;

      const secoes = this.items.filter(secao => this.modelValue.some(id => `${id}` === `${secao.id}`));
      this.updateModel(arrayColumn(secoes, 'id'));
    },
    apendarVirgula (item) {
      const indexOf = this.modelValue.indexOf(item.id)
      return indexOf !== this.modelValue.length - 1 && indexOf < (this.qtdeVisivelSelecionados - 1)
    }
  }
}
</script>

<style scoped>
.pl-14px {
  padding-left: 14px
}
.text-grat-900 {
  color: #999;
}
</style>
